import { PersistentSharedState } from '@trello/shared-state';
import { TrelloSessionStorage } from '@trello/storage';

export type MonitorStatus = 'idle' | 'active';

// This code should get deleted next week. It's only here to try and honor existing SessionStorage values.
let oldStatusValue: MonitorStatus | null = null;

try {
  oldStatusValue = TrelloSessionStorage.get('status');
  if (oldStatusValue) {
    TrelloSessionStorage.unset('status');
    TrelloSessionStorage.set(
      'trello.currentUserActivityStatus',
      oldStatusValue,
    );
  }
} catch {
  // This is genuinely a case of "we don't care if this throws". The logic in the try block is purely a kindness to
  // add some backwards compatibility, but it is very much self-healing.
}

export const monitorStatus = new PersistentSharedState<MonitorStatus>(
  oldStatusValue || 'idle',
  {
    session: true,
    storageKey: 'trello.currentUserActivityStatus',
  },
);
